'use client'

import React, { MouseEventHandler, useState } from 'react'
import { ChevronDown } from 'flowbite-react-icons/outline'

export const AccordionPanel = ({
  isInitialOpen = true,
  title = '',
  children,
  hasBorderRadius = false,
  customTitleClass = '',
  customContentClass = '',
}: {
  isInitialOpen?: boolean
  title: string | React.ReactNode
  children?: React.ReactNode | string
  hasBorderRadius?: boolean
  customTitleClass?: string
  customContentClass?: string
}) => {
  const [isOpen, setIsOpen] = useState(isInitialOpen)

  return (
    <section>
      <button
        className={`${customTitleClass} ${hasBorderRadius ? (isOpen ? 'rounded-t-lg' : 'rounded-lg') : ''} border-b font-semibold w-full py-4 text-left transition duration-300`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <span
          className={`float-right transform ${
            isOpen ? 'rotate-180' : 'rotate-0'
          } transition-transform duration-300`}
        >
          <ChevronDown />
        </span>
      </button>
      {isOpen && (
        <div
          className={`${customContentClass} ${hasBorderRadius ? 'rounded-b-lg' : ''} py-4 bg-white`}
        >
          {children}
        </div>
      )}
    </section>
  )
}
